module.exports = __webpack_public_path__ + "static/media/Price Pack Architecture.cffe5063.svg";